var exports = {
  "kL": "StickerGridItem.module__container___N1lxS0",
  "Bd": "StickerGridItem.module__stickerWrapper___N1lxS0",
  "HF": "StickerGridItem.module__stickerImage___N1lxS0",
  "Qs": "StickerGridItem.module__content___N1lxS0",
  "wx": "StickerGridItem.module__header___N1lxS0",
  "Zl": "StickerGridItem.module__stickerName___N1lxS0",
  "mr": "StickerGridItem.module__authorInfo___N1lxS0",
  "Du": "StickerGridItem.module__authorAvatar___N1lxS0",
  "fh": "StickerGridItem.module__authorName___N1lxS0",
  "o1": "StickerGridItem.module__actions___N1lxS0",
  "hP": "StickerGridItem.module__actionButton___N1lxS0" + " " + __webpack_require__(180357)["AS"] + " " + __webpack_require__(180357)["ik"],
  "G5": "StickerGridItem.module__deleteButton___N1lxS0",
  "Kk": "StickerGridItem.module__icon___N1lxS0",
};

module.exports = exports;
